<mat-progress-bar *ngIf="pageState === 'waiting'" mode="indeterminate">
</mat-progress-bar>

<div *ngIf="pageState === 'error'" class="extra-narrow-content">
  <mat-card>
    <mat-card-header>
      <mat-card-title> Could not load organization. </mat-card-title>
    </mat-card-header>
  </mat-card>
</div>

<div *ngIf="pageState === 'ready'" class="extra-narrow-content">
  <mat-card>
    <mat-card-content>
      <h1>Organization settings</h1>
      <h3 *ngIf="!canEditName">Name: {{ name }}</h3>
      <div class="edit-text" *ngIf="canEditName">
        <mat-form-field class="auto-margin">
          <mat-label>Organization name</mat-label>
          <input
            [formControl]="nameControl"
            matInput
            (keydown.enter)="saveName()"
          />
        </mat-form-field>
        <div class="auto-margin">
          <button
            mat-raised-button
            color="primary"
            [disabled]="!nameChanged || nameUpdateState === 'waiting'"
            (click)="saveName()"
          >
            <mat-icon *ngIf="nameUpdateState === 'waiting'">
              <mat-spinner
                [color]="'accent'"
                [mode]="'indeterminate'"
                [diameter]="20"
              >
              </mat-spinner>
            </mat-icon>
            {{
              nameUpdateState === 'waiting'
                ? 'Saving'
                : nameUpdateState === 'complete'
                ? 'Saved'
                : 'Save'
            }}
          </button>
        </div>
      </div>

      <div *ngIf="isAdmin">
        <h3>
          Billing:
          <a class="text-link" [routerLink]="'/org/' + org._id + '/billing'"
            >view settings</a
          >
        </h3>
      </div>

      <div class="standard-list">
        <div class="header-button">
          <h3 class="auto-margin">Spaces</h3>
        </div>
        <div>
          <div class="list-item" *ngFor="let space of spaces">
            <div class="list-item-title">{{ space.name }}</div>

            <a
              class="list-button"
              [routerLink]="['/org', org._id, 'space', space._id, 'edit']"
            >
              <button mat-stroked-button>
                {{ isAdmin ? 'EDIT' : 'VIEW' }}
              </button>
            </a>
          </div>
        </div>
        <p *ngIf="spaces.length === 0" class="no-entries">No spaces found</p>
        <div *ngIf="isAdmin" class="add-button">
          <button mat-stroked-button (click)="createSpaceDialog()">
            <mat-icon mat-button-icon>add</mat-icon>
            Create space
          </button>
        </div>
      </div>

      <div class="standard-list">
        <div class="header-button">
          <h3 class="auto-margin">Users</h3>
        </div>
        <div>
          <div class="list-item" *ngFor="let u of users">
            <div class="list-item-title">
              <div>
                {{ u.user.name }}
                <span *ngIf="u.user.admin" class="dim-text"
                  >&nbsp;&nbsp;Admin
                </span>
              </div>

              <div class="pill-container">
                <div *ngIf="u.invitedPending" class="pill invite-pill">
                  Invite pending
                </div>
                <div
                  *ngIf="
                    !u.user.archivedAt && !u.user.accountId && !u.invitedPending
                  "
                  class="pill invite-expired-pill"
                >
                  Invite expired
                </div>
                <div *ngIf="u.user.archivedAt" class="pill archive-pill">
                  Archived
                </div>
              </div>
            </div>

            <a
              *ngIf="isAdmin"
              class="list-button"
              [routerLink]="['/org', org._id, 'user', u.user._id, 'edit']"
            >
              <button mat-stroked-button>EDIT</button>
            </a>
          </div>
        </div>
        <button
          *ngIf="showShowArchivedUsersButton"
          mat-stroked-button
          (click)="showArchivedUsers()"
        >
          <mat-icon mat-button-icon>visibility</mat-icon>
          Show archived users
        </button>
        <div *ngIf="isAdmin" class="add-button">
          <a [routerLink]="['/org', org._id, 'user-add']">
            <button mat-stroked-button>
              <mat-icon mat-button-icon>add</mat-icon>
              Add users
            </button>
          </a>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>
